import {format} from 'date-fns'

// Handle day cell mount for floating icon functionality
export const handleDayCellDidMount = (
  info: any,
  setHoveredDate: any,
  setHoverPosition: any,
  calendarContainerRef: any
) => {
  const {el, date, isDisabled, ...rest} = info

  // Add hover event listeners to the day cell
  const handleMouseEnter = () => {
    if (isDisabled) {
      setHoveredDate(null)
      return
    }

    setHoveredDate({
      date: format(new Date(date), 'yyyy-MM-dd'),
      el,
      isDisabled,
      ...rest,
    })

    // Calculate position for floating icon - positioned in top left corner of the day cell
    const rect = el.getBoundingClientRect()
    const containerRect = calendarContainerRef.current?.getBoundingClientRect()

    if (containerRect) {
      setHoverPosition({
        x: rect.left - containerRect.left + 8, // 8px from left edge (reduced from 10px)
        y: rect.top - containerRect.top + 8, // 8px from top edge (reduced from 10px)
      })
    }
  }

  const handleMouseLeave = (e: MouseEvent) => {
    // Check if the mouse is moving to the floating icon
    const floatingIcon = document.querySelector('.floating-plus-icon') as HTMLElement
    if (floatingIcon && floatingIcon.contains(e.relatedTarget as Node)) {
      return // Don't hide if moving to the floating icon
    }
    setHoveredDate(null)
  }

  // Remove existing listeners if any
  if (el._hoverListeners) {
    const {handleMouseEnter: oldEnter, handleMouseLeave: oldLeave} = el._hoverListeners
    el.removeEventListener('mouseenter', oldEnter)
    el.removeEventListener('mouseleave', oldLeave)
  }
  // Add event listeners
  el.addEventListener('mouseenter', handleMouseEnter)
  el.addEventListener('mouseleave', handleMouseLeave)

  // Store the event listeners for cleanup
  el._hoverListeners = {handleMouseEnter, handleMouseLeave}
}
